import { Component, Input } from '@angular/core';

@Component({
  selector: 'sa-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() label: string;
  @Input() sublabel: string;
}
